import type { InputMap } from './index'
import type { FormKitConfig, FormKitNode } from '@formkit/core'

export function rootClasses(classes: InputMap): FormKitConfig['rootClasses'] {
  return (section: string, node: FormKitNode) => {
    const inputClasses = classes[node.props.type]
    const globalClasses = classes.__globals ?? {}
    const familyClasses = classes[`family:${node.props.family}`]
      ? classes[`family:${node.props.family}`][section]
      : ''
    let sectionClasses =
      inputClasses && section in inputClasses
        ? inputClasses[section]
        : globalClasses[section]

    sectionClasses = `formkit-${section}${
      familyClasses ? ` ${familyClasses}` : ''
    }${sectionClasses ? ` ${sectionClasses}` : ''}`

    if (sectionClasses) {
      return sectionClasses.split(' ').reduce((acc, className) => {
        acc[className] = true
        return acc
      }, {} as Record<string, boolean>)
    }
    return {}
  }
}
